import { BreachPathAppGZDataProvider } from '../dataProvider/BreachPathAppGZDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class BreachPathAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, BreachPathAppGZDataProvider);
  }
}
